import { useIntl } from "react-intl";

import AccountCreation from "@/components/signup/account-creation";
import {
    WhiteScreenInput,
    WhiteScreenLayout,
    WhiteScreenSocial,
    WhiteScreenSubmit
} from "@/components/signup/layouts";
import { useLocalizedHref } from "@/libraries/web-framework";
import { experiments, useExperiment } from "@/utils/experiment";
import { getWacIntegrationUrl } from "@/utils/urls";

export const LoggedOutJiraPremium = () => {
    const intl = useIntl();
    const heading1 = intl.formatMessage(
        {
            id: "BxpUiSignup.SignupForm.header",
            defaultMessage: "Get started with {product}"
        },
        { product: "Jira" }
    );

    const heading2 = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.subheader.jsw.premium",
        defaultMessage:
            "30-day free trial for unlimited users on the Premium plan — no credit card needed"
    });

    const jiraPlusPage = useLocalizedHref("/software/jira/free");

    let continueUrl: string | undefined = undefined;

    const jiraPlusExperiment = useExperiment(experiments.twcg1444JiraPlusOptIn);
    if (jiraPlusExperiment.type === "enrolled") {
        jiraPlusExperiment.fireExposure();
        if (jiraPlusExperiment.value) {
            continueUrl = `${getWacIntegrationUrl()}${jiraPlusPage}`;
        }
    }

    return (
        <WhiteScreenLayout heading1={heading1} heading2={heading2}>
            <AccountCreation
                continueUrl={continueUrl}
                Input={<WhiteScreenInput />}
                Social={<WhiteScreenSocial />}
                Submit={<WhiteScreenSubmit />}
            />
        </WhiteScreenLayout>
    );
};
